import { useTranslation } from 'react-i18next';
import Separator from '../../../components/ui/separator';
import useMemoizedValue from '../../../hooks/useMemoizedValue';

function formatPrice(price: number) {
  return price.toLocaleString('id-ID');
}

interface OtherCardProps {
  product_id?: number;
  name_prd?: string;
  price_prd?: number;
  image_prd?: string;
  className: string;
}

export default function OtherCard({ product_id, className = '', name_prd, price_prd, image_prd }: OtherCardProps) {
  const formattedPrice = useMemoizedValue(() => formatPrice(price_prd || 0), [formatPrice]);
  const { t } = useTranslation();

  return (
    <div
      className={`${className} sm:h-64 h-48 shadow-md text-start overflow-hidden bg-cover rounded-lg cursor-pointer hover:drop-shadow-md bg-center transition-all duration-300 ease-in-out`}
      style={{ backgroundImage: `url(${image_prd || '/assets/no-data-image.svg'})` }}
    >
      <div className="h-full w-full text-white flex justify-end items-center flex-col hover:bg-black/30 transition-all duration-300 ease-in-out">
        <div className="flex flex-col w-full bg-gradient-to-t from-primary via-primary to-transparent rounded-md drop-shadow-lg sm:gap-2 gap-1 sm:p-3 p-2">
          <div title={name_prd} className="flex gap-1 font-semibold">
            <h1 className="sm:text-sm text-xs overflow-hidden whitespace-nowrap text-ellipsis">{name_prd}</h1>
          </div>
          <Separator />
          <div className="flex flex-col text-start">
            <p className="sm:text-[0.5rem] text-[0.4rem] font-medium">{t('general.startfrom')}</p>
            <div className="sm:text-xl text-base gap-1 flex text-currency font-semibold">
              <p>IDR</p>
              <h1>{formattedPrice}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
